export default __webpack_public_path__ + "static/media/gallery_01.7c18d4da.jpg";